<template>
  <body
    class="font-ubuntu h_menu"
  >
    <div id="body" class="theme-cyan">
      <header-view  v-if="getEmail" />

      <router-view />
    </div>
    <dev-test-modal />
  <user-auth />
  </body>
</template>


<script
  src="https://cdn.jsdelivr.net/npm/popper.js@1.16.0/dist/umd/popper.min.js"
  integrity="sha384-Q6E9RHvbIyZFJoft+2mJbHaEWldlvI9IOYy5n3zV9zzTtmI3UksdQRVvoxMfooAo"
  crossorigin="anonymous"
></script>
<script
  src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.min.js"
  integrity="sha384-wfSDF2E50Y2D1uUdj0O3uMBJnjuUD4Ih7YwaYd1iqfktj0Uod8GCExl3Og8ifwB6"
  crossorigin="anonymous"
></script>
<script src="@/assets/bundles/libscripts.bundle.js"></script>
<script src="@/assets/bundles/vendorscripts.bundle.js"></script>
<script src="@/assets/bundles/apexcharts.bundle.js"></script>
<script src="@/assets/bundles/jvectormap.bundle.js"></script>
<script src="@/assets/bundles/mainscripts.bundle.js"></script>

<script src="@/assets/plugins/dropzone/dropzone.js"></script>

<script>
import HeaderView from "@/components/common/HeaderView.vue";
import DevTestModal from "@/views/dev/tools/DevTestModal";
import UserAuth from "@/components/user/modal/UserAuth";
import eventbus from "@/store/modules/devEventBus";

export default {
  name: "app",
  components: {
    HeaderView: HeaderView,
    DevTestModal: DevTestModal,
    UserAuth: UserAuth,
  },

  data() {
    return {
      width: 1000,
    };
  },
  methods: {
    // myEventHandler() {
    //   // var size = window.innerWidth;
    //   // console.log("home :",size)
    //   // this.width = size
    //   // console.log(document.getElementsByClassName('topBodyArea').length)
    //   // if(size < 900){
    //   //     document.getElementsByClassName('topBodyArea')[0].classList.remove('h_menu')
    //   //     document.getElementsByClassName('topBodyArea')[0].classList.add('ls-closed')
    //   // } else {
    //   //         document.getElementsByClassName('topBodyArea')[0].classList.add('h_menu')
    //   //     document.getElementsByClassName('topBodyArea')[0].classList.remove('ls-closed')
    //   // }
    // },
  },
  computed: {
      getEmail() {
      console.log(
        "for login in in ...",
        this.$store.state.userStore.loginSuccess,
        this.$store.state.userStore.userEmail
      );
      var check = this.$store.state.userStore.loginSuccess;

      if (check) {
        console.log("gpdj...", this.$store.state.userStore.userEmail);
      }
      return check;
    },
    // size(){
    //     return window.innerWidth
    // }
  },
  watch: {
    // size(size){
    //     this.width = size
    // }
  },
  mounted() {
    // window.addEventListener('resize', this.myEventHandler);
  },

  created() {
    // window.addEventListener("resize", this.myEventHandler);

    this.width = window.innerWidth;

    console.log("i am home layout");
    eventbus.$on("showLeftMenu", (res) => {
      console.log("menu check", res);
      if (res == "show") {
        document
          .getElementsByClassName("topBodyArea")[0]
          .classList.add("overlay-open");
      } else if (res == "hide") {
        document
          .getElementsByClassName("topBodyArea")[0]
          .classList.remove("overlay-open");
      }
    });
  },
  destroyed() {
    // eventbus.$off('showLeftMenu')
    window.removeEventListener("resize", this.myEventHandler);
  },
};
</script>

<style>
@import "../assets/plugins/bootstrap/css/bootstrap.min.css";
@import "../assets/plugins/jvectormap/jquery-jvectormap-2.0.3.min.css";
@import "../assets/plugins/morrisjs/morris.min.css";
@import "../assets/plugins/dropzone/dropzone.css";
@import "../assets/css/amaze.style.min.css";

@import "../assets/css/font/Material-Design-Icons.css";
@import "../assets/css/font/Material-Design-Icons.min.css";

@import "../assets/css/chatapp.css";
@import "../assets/css/inbox.css";
@import url(https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css);
</style>
